// removed by extract-text-webpack-plugin
module.exports = {"container":"container_zY1DR","flexbox":"flexbox_2kGiU","row-1":"row-1_Dmdhz","row-2":"row-2_3gfgl","rule":"rule_1uoxG","radioGroup":"radioGroup_1XWcu","check":"check_14nh4","radioItem":"radioItem_1Icff","list":"list_1z5ID","input":"input_1fe87","inputBox":"inputBox_2Uvaa","button":"button_1MuAI","error":"error_3xYw9"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/container/product/style.css
 ** module id = 949
 ** module chunks = 0
 **/